/**
 * AccordionHtmlFragment
 */

import React from 'react';
import { Accordion, AccordionItem } from 'components/Accordion';
import EpiFragments from 'components/EpiFragments';
import { StepsModel } from 'types/fragments';
import BlockContainer from 'layouts/BlockLayout';

interface Props {
	/** Child item list */
	steps?: StepsModel[];
}

/** AccordionHtmlFragment*/
const AccordionHtmlFragment: React.FC<Props> = ({ steps }) => {
	return (
		<BlockContainer noPadding>
			<Accordion>
				{steps?.map((step: any, index: number) => (
					<AccordionItem
						noHover
						title={step.heading}
						variant="html"
						key={index}
					>
						<EpiFragments fragments={step.fragments} />
					</AccordionItem>
				))}
			</Accordion>
		</BlockContainer>
	);
};

export default AccordionHtmlFragment;
